import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PoswarehouseService {


  url = environment.serverAPI5 + "/api/poswarehouse";

  url1 = environment.serverAPI5 + "/api/warehousesProduct";

  constructor(private http: HttpClient) { }

  getAllWarehouse(Page: any, size: any, sort: any): Observable<Object> {
    return this.http.get(`${this.url}?page=${Page}&size=${size}&sort=${sort}`);
  }

  getAllWarehouseDropDown(): Observable<Object> {
    return this.http.get(`${this.url}/dropdown`);
  }
  deleteImage(data: any): Observable<Object> {
    return this.http.post(`${this.url}/deleteImage`, data);
  }

  getWarehouseById(id: number): Observable<Object> {
    return this.http.get(`${this.url}/${id}`);
  }

  addOrEditWarehouse(warehouses: any): Observable<Response[]> {
    return this.http.post<Response[]>(`${this.url}`, warehouses);
  }
  warehouseSearch(query, Page: any, size: any, sort: any): Observable<Object> {
    return this.http.get(`${this.url}/filter?search=${query}&page=${Page}&size=${size}&sort=${sort}`);
  }

  downloadWarehousesTemplate(): Observable<any> {
    return this.http.get(`${this.url}/template/download`, { responseType: 'arraybuffer', observe: 'response' });
  }
  deleteByWarehouseId(id: any): Observable<Object> {
    return this.http.delete(`${this.url}/${id}`);
  }
  downloadWarehouseReport(Page: number, size: number, sort, selectionWarehouse): Observable<any> {
    return this.http.post(`${this.url}/export/page?page=${Page}
		&size=${size}&sort=${sort}`, selectionWarehouse, {
      responseType: 'arraybuffer',
      observe: 'response'
    });
  }

  addCreditWarehouse(warehouses: any): Observable<Response[]> {
    return this.http.post<Response[]>(`${this.url}/addAmount`, warehouses);
  }

  addTransferToWarehouse(warehouses: any): Observable<Response[]> {
    return this.http.post<Response[]>(`${this.url}/transfer`, warehouses);
  }

  getProductIdAndWarehouseIdByBatchNo(productId: any ,warehouseId:any): Observable<Object> {
		return this.http.get(`${this.url1}/batchNo/${productId}/${warehouseId}`);
	}

  updateWarehouseProduct(products: any): Observable<Response[]> {
    return this.http.post<Response[]>(`${this.url1}`, products);
  }

  getWarehouseHierarchy(): Observable<any> {
    return this.http.get(`${this.url}/hierarchy`);
  }

  getWarehouseHierarchyById(id: number): Observable<any> {
    return this.http.get(`${this.url}/hierarchy/${id}`);
  }

  getWarehouseAncestors(id: number): Observable<any> {
    return this.http.get(`${this.url}/${id}/ancestors`);
  }

}

